import React, { useEffect, useState } from 'react';
import './shop.css'
import {FaHeart, FaEye} from "react-icons/fa";
import { Link, useNavigate } from 'react-router-dom';
// import { IoMdClose } from "react-icons/io";


const Shop = ({shop,Filter,allcatefilter, addtocart}) => {
    //toggle product detail
    // const[showDetail, setShowDetail] = useState(false)
    //detail page data
    const[detail, setDetail] = useState([])
    //showing detail box
     const navigate = useNavigate();
    
      // Navigate to detail page
      const detailpage = (product) => {
        navigate(`/product-detail/${product.id}`, { state: product });
      };

    let currentImageIndex = 0;
const images = [detail.image, detail.image2, detail.image3, detail.image4].filter(Boolean) // Add your image array here
console.log('Images length:', images.length);

 const [country, setCountry] = useState("US");
  const [currency, setCurrency] = useState("USD");
  const [exchangeRateLoaded, setExchangeRateLoaded] = useState(false);

   // Detect user's country
    useEffect(() => {
      const fetchCountry = async () => {
        try {
          const res = await fetch("https://ipapi.co/json/");
          const data = await res.json();
          setCountry(data.country_code || "US");
        } catch (err) {
          console.error("Location error:", err);
          setCountry("US");
        } finally {
          setExchangeRateLoaded(true);
        }
      };
      fetchCountry();
    }, []);
  
    // Currency logic (all prices are stored in Naira)
    const getDisplayedPrice = (price) => {
      const basePrice = Number(price);
  
      // Nigerians see Naira prices directly
      if (country === "NG") {
        return `₦${basePrice.toLocaleString()}`;
      }
  
      // Others see converted USD equivalent
      const usdRate = 1437; // current NGN/USD approximate
      const converted = basePrice / usdRate;
  
      return new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: currency || "USD",
        maximumFractionDigits: 2,
      }).format(converted);
    };
  
function setImage(image) {
    document.getElementById('mainImage').src = image;
}

function changeImage(direction) {
    currentImageIndex += direction;

    if (currentImageIndex < 0) {
        currentImageIndex = images.length - 1; // Loop to last image
    } else if (currentImageIndex >= images.length) {
        currentImageIndex = 0; // Loop to first image
    }

    setImage(images[currentImageIndex]);
}
  return (
    <>
 
    <div className='shop'>
        <h2># shop</h2>
        <p>Home . Shop</p>
        <div className='container'>
            <div className='left_box'>
                <div className='category'>
                    <div className='header'>
                        <h3>all categories</h3>
                    </div>
                    <div className='box'>
                        <ul>
                            <li onClick={() => allcatefilter ()} onTouchEnd={() => allcatefilter ()}># All</li>
                            <li onClick={() => Filter("shirt")} onTouchEnd={() => Filter("shirt")}># top</li>
                            <li onClick={() => Filter("jean")} onTouchEnd={() => Filter("jean")}># pants</li>
                            <li onClick={() => Filter("fullfit")} onTouchEnd={() => Filter("fullfit")}># full fit</li>
                            {/* <li onClick={() => Filter("shirt")} onTouchEnd={() => Filter("shirt")}># hoodies</li>
                            <li onClick={() => Filter("electronics")} onTouchEnd={() => Filter("jean")}># shoes</li>
                            <li onClick={() => Filter("headphone")} onTouchEnd={() => Filter("jean")}># thrift</li>
                            <li onClick={() => Filter("phone")} onTouchEnd={() => Filter("jean")}># bags</li> */}
                        </ul>
                    </div>
                </div>
                <div className='banner'>
                    <div className='img_box'>
                        <img src='image/shop_left.avif' alt=''></img>
                    </div>
                </div>
            </div>
            <div className='right-box'>
                <div className='banner'>
                    <div className='img_box'>
                        <img src='image/shop_top.webp' alt=''></img>
                    </div>
                </div>
                <div className='product_box'>
                    <h2>Shop Product</h2>
                    <div className='product_container'>
                        {
                            shop.map((curElm) =>{
                        <div className='box'></div>
                                return(
                                    <>
                        <div className='box'>
                            <div className='img_box'>
                                <img src={curElm.image} alt=''></img>
                                <div className='icon'>
                                <li> <FaHeart /></li> 
                                <li onClick={() =>detailpage (curElm)}> <FaEye /></li>
                                </div>
                            </div>
                            <div className='detail'>
                                <h3>{curElm.Name}</h3>
                               <p className='price'>
              {exchangeRateLoaded ? getDisplayedPrice(curElm.price) : "Loading..."}
                                </p>
                                <button onClick={() => addtocart (curElm)}>Add To Cart</button>
                            </div>
                        </div>
                                    </>
                                )
                            })
                        }
                    </div>
                </div>
            </div>
        </div>
    </div>
    </>
  )
}

export default Shop